import {LatLng} from "../../models/common/lat-lng";
import {Country} from "../../models/common/country.model";

export class TransportationAgency {
    rowId: number;
    placeId: string;
    agencyName: string;
    crNumber: number;
    motAgencyLicenseNumber: string;
    phoneNumber: string;
    website: string;
    location: LatLng;
    country: Country;
    address: string;
    logo: string;
    emailAddress: string;
    defaultContactId: number;
    companyId: number;
}
